import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, Input, HostBinding, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { API } from 'src/app/configs';

@Component({
  selector: 'terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})

export class TermsComponent {
  
  terms:any = '';

  _overlay: boolean;
  @HostBinding('className') className = '';

  @Input()
  set overlay(val: boolean) {
    this.overlayChange.emit(val);
    this._overlay = val;
    this.className= this._overlay? 'overlay' : '';
  }
  get overlay() {
    return this._overlay;
  }
  @Output() overlayChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  data:any = {};

  loading = true;

  constructor(
    private httpClient: HttpClient,
    private dialogRef: MatDialogRef<TermsComponent>
  ){
    const headers= new HttpHeaders()
      .set('Accept', 'text/html')
      .set('Content-Type', 'text/plain; charset=utf-8')
      .set('Access-Control-Allow-Origin', '*');
      
    this.httpClient.get(API.general.terms,{ headers : headers, responseType: 'text' })
      .subscribe(
          data => { 
            this.terms = data;
            this.loading = false;
          },
          (err: HttpErrorResponse) => {
              console.log(err);
              this.loading = false;
          });
  }

  onClose(){
    this.dialogRef.close();
  }

}
